import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  positions: [],
  fetchLoading: false,
  singlePosition: null,
};

const slice = createSlice({
  name: "season",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updatePositionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.positions = state.positions.map((position) => {
        if (position.id === action.payload.id) {
          return action.payload;
        }
        return position;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getPositionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.positions = action.payload;
    },

    // GET SINGLE SUCCESS
    getSinglePositionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singlePosition = action.payload;
    },

    // GET PRODUCTS
    createPositionSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.positions = [...state.positions, action.payload];
    },

    // DELETE EVENT
    deletePositionSuccess(state, action) {
      const postionId = action.payload;
      state.positions = state.positions.filter(
        (position) => position.slug !== postionId
      );
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getPositions() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("positions");
      dispatch(slice.actions.getPositionSuccess(response.data.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSinglePosition({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`positions/${id}`);
      dispatch(slice.actions.getSinglePositionSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createPosition({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("positions", data);
      dispatch(slice.actions.createPositionSuccess(response.data.data));
      enqueueSnackbar("Position is added successfully");
      navigate(PATH_DASHBOARD.settings.positions.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updatePosition({ id, data, enqueueSnackbar, setOpenEdit }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`positions/${id}`, data);
      dispatch(slice.actions.updatePositionSuccess(response.data.data));
      enqueueSnackbar("Position is updated successfully");
      setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deletePosition({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`positions/${id}`);
      dispatch(slice.actions.deletePositionSuccess(id));
      enqueueSnackbar("Position is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
